// @ts-nocheck

import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { Target } from '../../client';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import NumericKeyboard from '../common/NumericKeyboard';
import OverModal from '../OverModal';
import RoundedButton from '../RoundedButton';
import StakeInput from '../StakeInput';

const Modal = styled(OverModal)`
  .modal-content {
    background-color: ${theme.Basket.keyboardMobileModalBackgroundColor};
  }
`;
const StyledRoundedButton = styled(RoundedButton)`
  margin: 10px;
  text-transform: capitalize;
  font-size: 1.2em;
`;

type HistoryItemCashoutStakeProps = {
  className?: string;
  stake: string;
  shouldOpenKeyboardModal: boolean;
  placeholderLabel: string;
  onStakeChange: (...params: unknown) => unknown;
};

const HistoryItemCashoutStake = ({
  className,
  stake,
  placeholderLabel,
  shouldOpenKeyboardModal = Target.__MOBILE__,
  onStakeChange,
}: HistoryItemCashoutStakeProps) => {
  const [isStakeFocus, setIsStakeFocus] = useState(false);

  const onFocus = useCallback(() => {
    setIsStakeFocus(true);
  }, [setIsStakeFocus]);

  const onClick = useCallback(() => {
    setIsStakeFocus(false);
  }, [setIsStakeFocus]);

  const renderInput = useCallback(
    (className?: string) => (
      <StakeInput
        className={className}
        onStakeChange={onStakeChange}
        placeholderLabel={isStakeFocus && !className ? placeholderLabel : ''}
        stake={stake}
        onFocus={onFocus}
      />
    ),
    [onFocus, onStakeChange, placeholderLabel, stake, isStakeFocus],
  );

  if (shouldOpenKeyboardModal) {
    return (
      <>
        {renderInput(className)}
        <Modal isOpen={isStakeFocus} onClose={() => setIsStakeFocus(false)}>
          {renderInput()}
          <NumericKeyboard value={stake} onInputChange={onStakeChange} />
          <StyledRoundedButton
            onClick={onClick}
            label={__('ok')}
            color={theme.History.betslip.actions.buttonColor}
            backgroundColor={theme.History.betslip.actions.completeButtonBackgroundColor}
          />
        </Modal>
      </>
    );
  }

  return renderInput(className);
};

export default HistoryItemCashoutStake;
